import environment from '#/environment/environment';
import * as snippet from '@segment/snippet';

export const loadAnalytics = () => {
  if (!environment.segmentIOApiKey) {
    return;
  }

  const contents = snippet.min({
    host: 'cdn.segment.com',
    apiKey: environment.segmentIOApiKey,
    page: false,
  });

  // eslint-disable-next-line no-eval
  eval(contents);
};
